/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content pt-3 pb-4">
      <div class="container-fluid">
        <div class="service">
          <h2>
            Welcome, {{ profile.name }}
          </h2>
          <div class="service-list">
            <ul>
              <li>
                <router-link :to="{ name: 'billing_histories' }">
                  <img src="/assets/images/icon-billing.svg" alt="service" />
                  <span>Billing</span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'my_package' }">
                  <img src="/assets/images/icon-package.svg" alt="service" />
                  <span>Package</span>
                </router-link>
              </li>
              <!-- <li>
                  <router-link :to="{name: 'dashboard'}">
                    <img src="/assets/images/icon-security.svg" alt="service" />
                  <span>Security Setup</span>
                  </router-link>
                </li> -->
              <!-- <li>
                <router-link :to="{ name: 'service_status' }">
                  <img src="/assets/images/icon-service-status.svg" alt="service" />
                  <span>Status</span>
                </router-link>
              </li> -->

              <!-- <li>
                <router-link :to="{ name: 'offers' }">
                  <img
                    src="/assets/images/icon-offer.svg"
                    alt="service"
                  />
                  <span>Offers</span>
                </router-link>
              </li> -->

              <!-- <li>
                <router-link :to="{ name: 'devices' }">
                  <img src="/assets/images/router-gradient.svg" alt="service" />
                  <span>Devices</span>
                </router-link>
              </li> -->
              <li>
                <a href="javascript:void(0);"
                @click.prevent ="goToHelp">
                  <img src="/assets/images/icon-support.svg" alt="service" />
                  <span>Help</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <div class="card">
            <div class="average-speed-wrap">
              <div class="row align-items-center">
                <div class="col-6">
                  <div class="average-speed">
                    <img src="/assets/images/icon-download.svg" alt="upgrade" />
                    <h2 class="heading">{{ packageInfo.downloadSpeed }} MB</h2>
                    <p class="mb-0 mb-md-2">Average speed</p>
                    <div class="average-speed-btn">
                      <button class="btn" type="button">Download</button>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="average-speed">
                    <img src="/assets/images/icon-upload.svg" alt="upgrade" />
                    <h2 class="heading">{{ packageInfo.uploadSpeed }} MB</h2>
                    <p class="mb-0 mb-md-2">Average speed</p>
                    <div class="average-speed-btn">
                      <button class="btn" type="button">Upload</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-md-6">
            <div class="card">
            <div class="">
              <div class="card-header">
                <h3 class="card-title">Recent Bills</h3>
              </div>
              <div class="overlay" v-if="recentBill.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <form action="">
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table common-table">
                      <thead>
                        <tr>
                          <th>Billing Month</th>
                          <th>Amount (£)</th>
                          <th>Status</th>
                          <th class="text-right">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(bill, index) in recentBill" :key="bill.id">
                          <td>{{ getFormattedDate(bill.invoice_at) }}</td>
                          <td>£ {{ formatNumber(bill.amount) }}</td>
                          <td><span :class="statusClasses[bill.status]">
                              <i :class="statusIcons[bill.status]"></i>
                              {{ bill.status }}
                            </span></td>
                          <td class="text-right"><button class="btn" @click.prevent="showRecentBillDetails(bill.id)"><i
                                class="far fa-file mr-1"></i> Details</button></td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
          </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        <h3 class="card-title">Recent Tickets</h3>
                      </div>
                      <form action="">
                        <div class="card-body p-0">
                          <div class="overlay" v-if="recentTicket.is_loading">
                            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                          </div>
                          <div class="table-responsive">
                            <table class="table common-table">
                              <thead>
                                <tr>
                                  <th>Ticket ID</th>
                                  <th>Subject</th>
                                  <th>Last Update</th>
                                  <th class="text-right">Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in recentTicket.data" :key="item.id">
                                  <td><router-link :to="{
                                    name: 'ticket-details',
                                    params: { id: item.id },
                                  }">#{{ item.id }}</router-link></td>
                                  <td>{{ item.subject }}</td>
                                  <td>{{ item.lastUpdate }}</td>
                                  <td class="text-right"><button class="btn" :class="item.className">{{
                                    item.status
                                      }}</button></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="p-4" v-if="_.isEmpty(recentTicket.data) && !recentTicket.is_loading">
                            <div class="alert alert-default-warning" role="alert">
                              No data found!
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="card-footer">
                        <vue-pagination :pagination="recentTicket" v-if="recentTicket.total > recentTicket.per_page"
                          @paginate="getTicketList()" />
                      </div>
                    </div>
                  </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>

    <div id="connectionModal" class="modal fade connection-modal" ref="connectionModalRef" data-backdrop="static">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content rounded">
          <button ref="connectionModalClose" type="button" class="close d-none" data-dismiss="modal">
            <i class="fas fa-times"></i>
          </button>
          <h5 class="modal-title">Choose one of your connection</h5>
          <div class="connection-list">
            <label v-for="(val, index) in activeConnections.data" :key="'active_connections_' + index"
              :class="{ active: selectedConnection === val.id }">
              <input type="radio" name="package" />
              <div v-on:click.prevent.stop="setSelectedConnection(val.id)" class="connection-list-box">
                <h3>
                  ID - {{ val.username }}
                  <span>( {{ val.client_state }} )</span>
                </h3>
                <h5>{{ val.service_name }}</h5>
                <p>{{ !_.isEmpty(val.address) ? val.address : val.city }}</p>
              </div>
            </label>
          </div>
          <button v-on:click.prevent.stop="setConnection" class="btn btn-blue" :disabled="!selectedConnection">
            Continue
          </button>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="upgradeModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content upgrade-modal">
          <div class="modal-body">
            <img src="/assets/images/icon-upgrade-package.svg" alt="" />
            <h5 class="modal-title">Upgrade your package now.</h5>
            <p>
              A Ticket will be raised upon upgrade package request. One of our
              Customer Care agent will follow your request as soon as possible.
            </p>
            <div class="d-flex">
              <button type="button" class="btn" data-dismiss="modal" aria-label="Close" ref="CloseBtn">
                No
              </button>
              <a class="btn" @click.prevent="upgradePackageRequest">Yes</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- recent bill modal -->
    <div class="modal fade" id="recentBillDetailModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="detailModalLabel">Billing Details</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Billing Month</th>
                  <th scope="col">Particulars</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Invoice at</th>
                  <th scope="col">Bill status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, i) in recent_bill_details" :key="v.id">
                  <td scope="col">{{ getFormattedDate(v.invoice_at) }}</td>
                  <td scope="col">{{ v.service_name }}</td>
                  <td scope="col">{{ formatNumber(v.service_charge) }}</td>
                  <td scope="col">{{ v.invoice_at }}</td>
                  <td scope="col">{{ v.status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div id="getPackageModal" class="modal fade connection-modal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <button ref="Close" type="button" class="close" data-dismiss="modal">
            <i class="fas fa-times"></i>
          </button>
          <h2 class="modal-title">Do you want to proceed?</h2>
          <div class="get-package">
            <div class="get-package-box">
              <h5>Current Package</h5>
              <h3>
                {{ value.package + " " + "@" + value.monthlyAmount }}
                <!-- 30 Mbps @1599 -->
              </h3>
            </div>
            <div class="get-package-box">
              <h5>Requested Package</h5>
              <h3>
                {{
                  selectedPackage
                    ? selectedPackage.service_name +
                    " " +
                    "@" +
                    selectedPackage.service_charge
                    : ""
                }}
                <!-- 40 Mbps @1999 -->
              </h3>
            </div>
          </div>
          <button @click="requestForPackageUpdate" class="btn btn-blue">
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
div.closed {
  /* background: green; */
  background: #caffd6;
  color: #119a30;
}

div.pending {
  background: #ffe9dd;
  /* color: #119A30; */
}

div.open {
  background: #ffe9dd;
}

div.in-progress {
  background: #ffe9dd;
}

/* div.breadcrumb-title{
  width: 50% !important;
}
div.breadcrumb-content{
  width: 50% !important;
} */
.btn:disabled {
  filter: grayscale(1);
  opacity: 0.35;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { Capacitor } from "@capacitor/core";
import axios from "axios";
// import $ from "jquery";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueHighcharts from "vue2-highcharts";
import { mapActions, mapGetters } from "vuex";
import { CommonAPI, SelfcareAPI } from "@/services/api";
import { round, thru } from "lodash";

const fileDownload = require("js-file-download");

export default {
  name: "Dashboard",
  metaInfo: {
    title: "Dashboard | Carnival Internet",
  },

  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    VueHighcharts,
  },

  data: () => ({
    selectedPackage: null,
    selectedConnection: null,

    value: {
      is_loading: true,
      package: "",
      monthlyAmount: 0,
      availableBalance: 0,
      billDueDate: "",
    },

    ticketList: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: [],
    },
    recentTicket: {
      is_loading: true,
      data: [],
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    recentBill: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    statusClasses: {
      Paid: "paid",
      Cancelled: "cancelled",
      Refunded: "refunded",
      Pending: "pending",
      Failed: "failed",
      Created: "created",
    },
    statusIcons: {
      Paid: "fa fa-check",
      Cancelled: "fa fa-times",
      Refunded: "fa fa-undo",
      Pending: "fa fa-hourglass-half",
      Failed: "fa fa-exclamation-triangle",
      Created: "",
    },

    betterPackges: {
      is_loading: true,
      data: [],
    },

    activeConnections: {
      is_loading: true,
      data: [],
    },

    ads: {
      is_loading: true,
      data: [],
    },

    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: [],
      tickets: [],
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    key: "",
    iv: "",

    recent_bill_details: []
  }),

  computed: {
    ...mapGetters(["profile", "packageInfo", "accountInfo"]),
  },

  beforeMount: function () {
    // console.log("*******************Showing loading bar*******************");
    // window.$("loading__container").css({ display: "block" });
  },
  // method is called after page load
  mounted: function () {
    // window.$("loading__container").fadeOut(1500);
    // $("#loading__container").fadeOut(2000, "swing", () => {
    //   console.log("Fadeout Complete");
    // });

    if (this.isMobile()) {
      var sidebarElem = window.$(document).find(".sidebar-mini");
      if ($(sidebarElem).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
    }

    // var iv = this.$CryptoJS.lib.WordArray.random(16);
    // console.log("IV:", iv);
    const key = process.env.VUE_APP_AES_KEY;
    const iv = process.env.VUE_APP_AES_IV;
    // let data = this.AesEncrypt("Hi!, Danial.");
    // console.log("Crypto Data::", data);
    this.getTicketList();
    // this.getInvoiceData();
    this.getPackageInfo();
    this.getRecentBillList();
    // this.nextBetterPackges();
    this.getActiveConnections();
    // this.getAds();
    // this.api_url = "/admin_users";
    // this.getUsageData()
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      // this.getUsageData()
    });

  },
  methods: {
    ...mapActions(["FETCH_PROFILE", "FETCH_PACKAGE_INFO", "FETCH_ACCOUNT_INFO"]),

    CryptoJSAesEncrypt: function (passphrase, plain_text) {
      // const encryptedText = this.$CryptoJS.AES.encrypt("Hi There!", "Secret Passphrase").toString()
      // const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, "Secret Passphrase").toString(this.$CryptoJS.enc.Utf8)
      const cryptoRef = this.$CryptoJS;
      var salt = cryptoRef.lib.WordArray.random(256);
      var iv = cryptoRef.lib.WordArray.random(16);
      // for more random entropy can use : https://github.com/wwwtyro/cryptico/blob/master/random.js instead CryptoJS random() or another js PRNG
      var key = cryptoRef.PBKDF2(passphrase, salt, {
        hasher: cryptoRef.algo.SHA512,
        keySize: 64 / 8,
        iterations: 999,
      });

      var encrypted = cryptoRef.AES.encrypt(plain_text, key, { iv: iv });

      var data = {
        ciphertext: cryptoRef.enc.Base64.stringify(encrypted.ciphertext),
        salt: cryptoRef.enc.Hex.stringify(salt),
        iv: cryptoRef.enc.Hex.stringify(iv),
      };

      return JSON.stringify(data);
    },

    /*
    PHP function encrypt
    function encryptPhp($string) {
            $encrypt_method="AES-256-CBC";
            $secret_key='secret_key';
            $secret_iv='secret_iv';
            $key=hash('sha256',$secret_key);
            $iv=substr(hash('sha256',$secret_iv),0,16);
            $output=openssl_encrypt($string,$encrypt_method,$key,0,$iv);
            $output=base64_encode($output);
            return $output
    }, */

    AesEncrypt: function (plainText) {
      const cryptoRef = this.$CryptoJS;
      const Utf8 = cryptoRef.enc.Utf8;
      // var iv = cryptoRef.lib.WordArray.random(16);
      // console.log(iv);
      const $secret_key = this.key; // "!@#$123Dm<>*^%";
      const $secret_iv = this.iv; // "123456789";
      const key = cryptoRef
        .SHA256($secret_key)
        .toString(cryptoRef.enc.Hex)
        .substring(0, 256);
      const iv = cryptoRef
        .SHA256($secret_iv)
        .toString(cryptoRef.enc.Hex)
        .substring(0, 16);

      var encrypted = cryptoRef.AES.encrypt(plainText, Utf8.parse(key), {
        iv: Utf8.parse(iv),
      });
      //console.log("Encrypt Object::", encrypted);
      const base64cipherText = cryptoRef.enc.Base64.stringify(
        encrypted.ciphertext
      );
      return base64cipherText;
    },

    upgradePackageRequest() {
      const _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        _this.is_loading = true;
        axios
          .post("upgrade_package_request", {
            cuid: subscriber.id,
          })
          .then((response) => {
            //console.log("response.data::", response.data);
            const responseData = response.data;
            // _this.responseMessage = response.data.message;
            _this.is_loading = false;
            if (
              responseData != null &&
              (responseData.code == 200 || responseData.status == 200)
            ) {
              _this.$toaster.success(responseData.message);
            }

            _this.$nextTick(() => {
              // $("#upgradeModal").modal("hide");
              _this.$refs.CloseBtn.click();
            });
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
            _this.$nextTick(() => {
              // $("#upgradeModal").modal("hide");
              _this.$refs.CloseBtn.click();
            });
          });
      }
    },

    getRecentBillList: function () {
      let _this = this;
      _this.recentBill.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      query.cuid = subscriber ? subscriber.id : null;

      SelfcareAPI.getMyBillingHistory(query)
        .then((response) => {
          _this.recentBill.is_loading = false;
          _this.recentBill = response;
          if (Array.isArray(response)) {
            _this.recentBill = response.slice(0, 3);
          } else {
            _this.recentBill = [];
          }

          // console.log("::::::Billing History:::::", JSON.stringify(response.slice(0, 3)));
        })
        .catch((error) => { })
        .finally(() => {
          _this.recentBill.is_loading = false;
        });
    },

    showRecentBillDetails(id) {

      let item = this.recentBill.find(o => o.id == id);
      // console.log(":::::::Request Package Info:::::::", item);
      if (item.type === 'Subscription') {

        let itemDescriptions = JSON.parse(item.items);
        // console.log("Subscription items data", itemDescriptions);
        if (Array.isArray(itemDescriptions) && itemDescriptions.length > 0) {
          this.recent_bill_details = itemDescriptions.map(subscriptionItem => ({
            service_name: subscriptionItem.productName,
            service_charge: round(subscriptionItem.amount / 100, 2),
            invoice_at: item.invoice_at,
            status: item.status
          }));

        }
      } else {
        let remarks = JSON.parse(item.remarks);
        // console.log("::::Remarks::::", remarks);
        if (remarks) {
          this.recent_bill_details = remarks.requestPackageInfos;
        }
        if (this.recent_bill_details && this.recent_bill_details.length > 0) {
          this.recent_bill_details = this.recent_bill_details.map(o => {
            o.invoice_at = item.invoice_at; //moment(item.invoice_at).format("MMM-YY");
            o.status = item.status;
            return o;
          });
        } else {
          let serviceName = remarks.packageInfos?.service_name;
          this.recent_bill_details = [
            {
              service_name: serviceName ?? item.type,
              service_charge: item.amount,
              invoice_at: item.invoice_at,
              status: item.status
            }
          ];
        }
      }
      // console.log("::::Details::::",  this.recent_bill_details);
      this.$nextTick(() => {
        $('#recentBillDetailModal').modal('show');
      });

    },


    getTicketList() {
      this.recentTicket.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      this.recentTicket.data = [
        // {
        //   subject: "#92762990 Get A Call Back", lastUpdate: '12/02/2022', status: 'Open'
        // },
      ];

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);

      if (subscriber) {
        query.cuid = subscriber.username;
        axios({
          method: "get",
          url: "/get-ticket",
          headers: { "Content-Type": "application/json" },
          params: query,
        })
          .then((response) => {
            //console.log("Res::", response)
            // console.log("Response Data::", response);
            response.data.data.length > 0
              ? response.data.data.map((o) => {
                o.lastUpdate = moment(o.updated_at).format("DD MMM YYYY");
                o.subject = o.title;
                let state =
                  o.ticket_state && o.ticket_state.states
                    ? o.ticket_state.states
                    : "";
                let state_names = state.split(/[ ,]+/);
                let className =
                  state_names.length > 0 ? state_names.join("-").toLowerCase() : "";
                o.className = className;

                o.status =
                  o.ticket_state && o.ticket_state.states
                    ? o.ticket_state.states
                    : "NA";
                return o;
              })
              : [];
            //  console.log("data::", data)
            response.data.data.length > 0
              ? response.data.data.sort((a, b) => {
                return moment(b.updated_at) - moment(a.updated_at);
              })
              : [];
            this.recentTicket = response.data;

            this.recentTicket.is_loading = false;
          })
          .catch((error) => {
            this.recentTicket.is_loading = false;
          });
      }
    },
    getFormattedDate(date) {
      return moment(date).format("MMM-YY");
    },

    formatNumber(value) {
      return parseFloat(value).toFixed(2);
    },

    upgradePackage: function () {
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        const ecryptedSubscriberId = this.AesEncrypt(subscriber.id + ""); // encrypt subscriber id, Alg: AES
        const url = `https://stage.carnivalinternet.co.uk/upgradepackage?id=${ecryptedSubscriberId}`;
        if (!Capacitor.isNativePlatform()) {
          // window.location.href = redirectUrl;
          window.open(url, "_self");
        } else {
          // @ts-ignore
          const ref = cordova.InAppBrowser.open(
            url,
            "_blank",
            "location=yes,hideurlbar=yes"
          );

          const myCallback = function (event) {
            //console.log("Updated URL: ", event.url);
          };
          ref.addEventListener("loadstart", myCallback);
        }
      }
    },

    navigateToAddressChange: function () {
      this.$router.push({ name: "address-change-request" });
    },
    goToHelp: function () {
      let selfCareHelpLink = process.env.VUE_APP_HELP_BASE_URL;
      console.log("Env Link", selfCareHelpLink);
      selfCareHelpLink = selfCareHelpLink.replace(/^['"]+|['";]+$/g, '');
      console.log("Modified Link", selfCareHelpLink);
      // const redirectUrl = "https://help.rocket-fibre.co.uk";
      if (!Capacitor.isNativePlatform()) {
        // window.location.href = redirectUrl;
        window.open(selfCareHelpLink, "_blank", "noopener,noreferrer");
      } else {
        // @ts-ignore
        const ref = cordova.InAppBrowser.open(
          selfCareHelpLink,
          "_blank",
          "location=yes,hideurlbar=yes"
        );

        const myCallback = function (event) {
          //console.log("Updated URL: ", event.url);
        };
        ref.addEventListener("loadstart", myCallback);
      }
    },
    // update_subscriber_package
    requestForPackageUpdate: function () {
      const _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        axios({
          method: "post",
          url: "/requestForPackageUpdate",
          data: {
            cuid: subscriber.username,
            new_cbs_service_id: _this.selectedPackage.cbs_service_id,
          },
          headers: { "Content-Type": "application/json" },
        })
          .then(function (response) {
            // console.log(response.data);
            const responseData = response.data;
            if (responseData && responseData.status === 200) {
              _this.$toaster.success(responseData.message);
            } else {
              _this.$toaster.success(responseData.message);
            }
            _this.is_loading = false;
            _this.$refs.Close.click();
          })
          .catch((errors) => {
            _this.$setErrorsFromResponse(errors.response.data);
            _this.$refs.Close.click();
          })
          .finally(() => {
            _this.is_loading = false;
            _this.$refs.Close.click();
          });
      }
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    navigateToSupport: function () {
      this.$router.push({ name: "support" });
    },

    navigateToTicket: function () {
      this.$router.push({ name: "open-ticket" });
    },

    navigateToUsage: function () {
      this.$router.push({ name: "usage" });
    },

    navigateToPayment: function () {
      this.$router.push({ name: "paynow" });
    },

    setSelectedPackage(packageId) {
      this.selectedPackage =
        this.betterPackges.data.find((o) => o.cbs_service_id == packageId) ||
        null;
    },

    async loadConnectionDependentData() {
      this.getPackageInfo();
      this.getAccountInfo();
      this.getProfileInfo();
      // this.nextBetterPackges();
      this.$router.go(0);
    },

    setConnection() {
      let subscriber = this.activeConnections.data.find(
        (i) => i.id == this.selectedConnection
      );
      subscriber = JSON.stringify(subscriber);
      //console.log("Subscriber JSON::", subscriber);
      localStorage.setItem("subscriber", subscriber);
      this.$refs.connectionModalClose.click();
      this.$root.$emit('update-navbar', subscriber);
      this.loadConnectionDependentData();
    },

    setSelectedConnection(subscriberId) {
      this.selectedConnection = subscriberId;
      //console.log("Selected Conn::", subscriberId);
    },

    // connectionModal
    showModal() {
      const element = this.$refs.connectionModalRef;
      // console.log("Modal El::", element);

      window.$(element).modal("show");
      // this.$root.$emit("bv::show::modal", "#connectionModal");
    },

    getActiveConnections: function () {
      // get_active_connections
      const _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (!subscriber) {
        axios
          .get("/get_active_connections", {
            params: { cuid: subscriber ? subscriber.username : "" },
          })
          .then((response) => {
            //console.log("active_connections:: ", response.data);
            _this.activeConnections.data = response.data;
            if (_this.activeConnections.data.length === 1) {
              let subscriber = _this.activeConnections.data[0];
              subscriber = JSON.stringify(subscriber);
              localStorage.setItem("subscriber", subscriber);
              _this.loadConnectionDependentData();
            }
            if (_this.activeConnections.data.length > 1) {
              _this.showModal();
              //console.log("More than one connections");
            }
            _this.activeConnections.is_loading = false;
          })
          .catch((error) => {
            console.log("Error::", error);
            _this.activeConnections.is_loading = false;
          })
          .finally(() => {
            _this.activeConnections.is_loading = false;
          });
      }
    },

    getPackageInfo: function () {
      this.FETCH_PACKAGE_INFO();
    },

    getAccountInfo: function () {
      this.FETCH_ACCOUNT_INFO();
    },

    getProfileInfo: function () {
      this.FETCH_PROFILE();
    },

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getUsageData();
    },
  },
};
</script>
